import React from 'react';
import { connect } from 'react-redux';
import ShippingEstimatesPage from './ShippingEstimatesPage';
import { RootState, Dispatch } from '../../../../state/store/store';
import carrierWeightPricingSelectors from '../../../../state/ducks/carrierWeightPricing/selectors';
import { localizationSelectors } from '../../../../state/ducks/localization/selectors';

type Props = {
    carrierWeightPricing: any[];
    carrierPricingResponse?: any;
    fetchPublicCarrierWeightPricingWithDimensions: (payload: { 
        weight: number; 
        quantity: number; 
        regionId: number; 
        length?: number; 
        width?: number; 
        height?: number; 
    }) => any;
    localization: any;
};

const ShippingEstimatesPageConnected = ({
    carrierWeightPricing,
    carrierPricingResponse,
    fetchPublicCarrierWeightPricingWithDimensions,
    localization
}: Props) => {
    return (
        <ShippingEstimatesPage
            carrierWeightPricing={carrierWeightPricing}
            carrierPricingResponse={carrierPricingResponse}
            fetchPublicCarrierWeightPricingWithDimensions={fetchPublicCarrierWeightPricingWithDimensions}
            localization={localization}
        />
    );
};

const mapStateToProps = (state: RootState) => ({
    carrierWeightPricing: carrierWeightPricingSelectors.carrierWeightPricing(state),
    carrierPricingResponse: carrierWeightPricingSelectors.carrierPricingResponse(state),
    localization: localizationSelectors.routes(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchPublicCarrierWeightPricingWithDimensions: (payload: { 
        weight: number; 
        quantity: number; 
        regionId: number; 
        length?: number; 
        width?: number; 
        height?: number; 
    }) => 
        dispatch.carrierWeightPricing.fetchPublicCarrierWeightPricingWithDimensions(payload)
});

export default connect(mapStateToProps, mapDispatchToProps)(ShippingEstimatesPageConnected);
